var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecords(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Records"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 14
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Records",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "folder_1_",
    "data-name": "folder (1)",
    className: "cls-2",
    d: "M15.485,9.875V7.007H7.456L6.169,5H.783A.785.785,0,0,0,0,5.784V18.477H0c0,.21-.013.287.162.287H13a.728.728,0,0,0,.7-.52l2.932-8.083V9.875ZM2.294,7.986v.742H1.553Zm12.617,1.6H12.617v-.86a.287.287,0,0,0-.574,0v.86H10.61v-.86a.287.287,0,0,0-.574,0v.86H8.6v-.86a.287.287,0,0,0-.574,0v.86H6.6v-.86a.287.287,0,0,0-.574,0v.86H4.588v-.86a.287.287,0,0,0-.574,0v.86H3.364a.728.728,0,0,0-.7.52L1.147,14.26V9.3H2.868V7.581H14.911Z",
    transform: "translate(0 -5)",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecords);
export default __webpack_public_path__ + "static/media/Records.b2d4d19a03932949b512c464203ccc97.svg";
export { ForwardRef as ReactComponent };